var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUnlock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    viewBox: "0 0 64 64",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Icon-Unlock",
    transform: "translate(334.000000, 430.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-313.2-401.2h-3v-6.4c0-7.8,6.4-14.2,14.2-14.2c7.2,0,13.2,5.3,14.1,12.4l-2.9,0.4     c-0.7-5.6-5.5-9.8-11.2-9.8c-6.2,0-11.2,5-11.2,11.2V-401.2",
    id: "Fill-70"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-289.3-374.2h-25.5c-2.6,0-4.8-2.1-4.8-4.8v-19.1c0-2.6,2.1-4.8,4.8-4.8h25.5     c2.6,0,4.8,2.1,4.8,4.8v19.1C-284.5-376.3-286.6-374.2-289.3-374.2L-289.3-374.2z M-314.7-399.6c-0.9,0-1.6,0.7-1.6,1.6v19.1     c0,0.9,0.7,1.6,1.6,1.6h25.5c0.9,0,1.6-0.7,1.6-1.6v-19.1c0-0.9-0.7-1.6-1.6-1.6H-314.7L-314.7-399.6z",
    id: "Fill-71"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-298.8-393.3c0,1.8-1.4,3.2-3.2,3.2s-3.2-1.4-3.2-3.2c0-1.8,1.4-3.2,3.2-3.2     S-298.8-395-298.8-393.3",
    id: "Fill-72"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    id: "Fill-73",
    points: "-301.2,-393.3 -302.8,-393.3 -304.4,-383.7 -299.6,-383.7 -301.2,-393.3    "
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlock);
export default __webpack_public_path__ + "static/media/unlock.8182c833.svg";
export { ForwardRef as ReactComponent };